import * as React from "react";
import styled, { css } from "styled-components";
import { transparentize } from "polished";
import { UnitKindEnum, unitsFormatter } from "app/utils/unitsFormatter";
import { observer } from "mobx-react";
import { Fonts } from "app/styling/fonts";

const NumberWithUnitView = styled.div`
  ${(props: { color?: string }) => css`
    color: ${props.color || "white"};
    text-align: center;
  `};
`;
const Values = styled.div`
  ${(props: {}) => css`
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    margin: 0 auto;
  `};
`;
const Value = styled.span`
  ${(props: { size?: string }) => css`
    font-size: ${props.size ? props.size : Fonts.FONT_SIZE};
    margin-right: 0.1rem;
  `};
`;
const Unit = styled.span`
  ${(props: { size?: string }) => css`
    text-transform: capitalize;
    font-size: ${props.size ? props.size : Fonts.FONT_SIZE_SMALL};
  `};
`;
const Title = styled.div`
  ${(props: { color?: string }) => css`
    font-size: 10px;
    color: ${transparentize(0.6, props.color || "white")};
    margin-top: 4px;
    text-transform: uppercase;
  `};
`;
interface Props {
  value: string;
  unit: string;
  title?: string | JSX.Element;

  color?: string;

  valueFontSize?: string;
  unitFontSize?: string;

  className?: string;
}

const initialState = {};
type State = Readonly<typeof initialState>;

@observer
export class NumberWithUnit extends React.Component<Props, State> {
  readonly state: State = initialState;

  render() {
    const { value, unit, title, className, color, valueFontSize, unitFontSize, ...restProps } = this.props;
    return (
      <NumberWithUnitView color={color} className={className} {...restProps}>
        <Values>
          <Value size={valueFontSize}>{value}</Value>
          <Unit size={unitFontSize}>{unit}</Unit>
        </Values>
        {title ? <Title color={color}>{title}</Title> : null}
      </NumberWithUnitView>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/numberWithUnits/NumberWithUnit.tsx